import * as React from "react";
import { Box } from "@mui/material";

// A pill-shaped button group built with a single shared border + manual dividers,
// instead of MUI's <ButtonGroup>, whose border-overlap technique renders inconsistently
// once child buttons carry their own custom sx (missing/doubled strokes between segments).
// Children should be <Button variant="text"> with no border of their own.
export default function PillButtonGroup({ children, disabled, sx }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "stretch",
        backgroundColor: "#FFFFFF",
        border: "1px solid #e0e0e0",
        borderRadius: 1.5,
        overflow: "hidden",
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? "none" : "auto",
        "& > button": { borderRadius: 0, textTransform: "none" },
        "& > button:not(:last-of-type)": { borderRight: "1px solid #e0e0e0" },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
